import React, { createContext, useContext } from 'react';
import { Brand } from '../types/global';

export type BrandName = `${Brand}`;
export type BrandLongName = 'NatWest' | 'RoyalBankofScotland' | 'UlsterBank' | 'NatWestGroup';

interface BrandProviderProps {
  brand?: Brand;
  children: React.ReactNode | React.ReactNode[];
}

interface BrandProviderInterface {
  brand: Brand;
  longName: BrandLongName;
  legalName: string;
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const BrandContext = createContext<BrandProviderInterface>();

function BrandProvider({ children, brand = Brand.NatWest }: BrandProviderProps) {
  const longNames: Record<string, BrandLongName> = {
    [Brand.NatWest]: 'NatWest',
    [Brand.RoyalBankOfScotland]: 'RoyalBankofScotland'
  };

  const legalNames: Record<string, string> = {
    [Brand.NatWest]: 'NatWest',
    [Brand.RoyalBankOfScotland]: 'Royal Bank of Scotland'
  };

  return (
    <BrandContext.Provider
      value={{
        brand,
        longName: longNames[brand],
        legalName: legalNames[brand]
      }}
    >
      <>{children}</>
    </BrandContext.Provider>
  );
}

export default function useBrand() {
  return useContext(BrandContext);
}

export { BrandProvider };
